import React from 'react'
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

interface Props {
  width?: number
  height?: number
}

const FailingIcon: React.FC<Props> = ({ width = 48, height = 49 }) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 48 49" fill="none">
      <G clipPath="url(#clip0)">
        {/* Outer circle */}
        <Path
          d="M24 42.281c9.941 0 18-8.059 18-18 0-9.94-8.059-18-18-18s-18 8.06-18 18c0 9.941 8.059 18 18 18Z"
          stroke="#CC293F"
          strokeWidth={3.556}
          strokeMiterlimit={10}
        />

        {/* Exclamation line */}
        <Path
          d="M24 25.781v-10.5"
          stroke="#B8255F"
          strokeWidth={3.556}
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* Dot of exclamation */}
        <Path
          d="M24 34.781a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z"
          fill="#B8255F"
        />
      </G>
      <Defs>
        <ClipPath id="clip0">
          <Path fill="#fff" d="M0 .281h48v48H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default FailingIcon
